module.exports = __webpack_public_path__ + "img/menual04.684ef562.svg";